import React from 'react';
import { motion } from 'framer-motion';
import { Award, GraduationCap } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function DespreCredentials() {
  const credentials = [{
    title: 'Instructor Internațional Theta Healing®',
    desc: 'Certificat de Theta Healing® Institute of Knowledge (THInK), SUA. Autorizat să predea cursuri în întreaga lume.'
  }, {
    title: 'Facilitator Heal Your Life',
    desc: 'Acreditat după metoda Louise Hay.'
  }, {
    title: 'Terapeut Theta Healing® și Tehnică Radiantă',
    desc: 'Acreditat de O.P.M.C.A. România.'
  }, {
    title: 'Consilier de Dezvoltare Personală',
    desc: 'Acreditat de Ministerul Muncii din România.'
  }, {
    title: 'Formator',
    desc: 'Acreditat de Ministerul Muncii din România.'
  }, {
    title: 'Absolvent Facultatea de Marketing',
    desc: 'Universitatea Vasile Goldiș, Arad, specializarea Economist Marketing-Management.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-1149">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1150">
        <SectionHeading title="Acreditări și Formare Profesională" data-id="element-1151" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center font-subtitle text-xl text-brand-textSec leading-relaxed max-w-3xl mx-auto -mt-4 mb-16" data-id="element-1152">
          Lucrez cu instrumente validate internațional, susținute de peste 25 de
          ani de studiu și practică în terapii complementare și dezvoltare
          personală.
        </motion.p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-1153">
          {credentials.map((cred, index) => {
          const Icon = index === credentials.length - 1 ? GraduationCap : Award;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="flex gap-5 bg-white rounded-2xl p-6 shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow duration-300" data-id="element-1154">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center text-brand-gold" data-id="element-1155">
                  <Icon className="w-6 h-6" data-id="element-1156" />
                </div>
                <div className="flex-grow" data-id="element-1157">
                  <h3 className="font-bold text-lg text-brand-text mb-1.5 leading-snug" data-id="element-1158">
                    {cred.title}
                  </h3>
                  <p className="text-brand-textSec leading-relaxed text-sm" data-id="element-1159">
                    {cred.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}